export default {
  copy: 'Example Eyebrow',
  component: 'a-eyebrow',
}
